import { Link } from "react-router-dom";
import { copyIcon } from "../../asset";
import CustomButton from "../CustomButton";
import ModalLayout from "../layouts/ModalLayout";
import { handleCopy } from "../../util/functions/UniversalFunctions";

interface Props {
  title: string;
  link: string;
  description?: string;
  onClose?: () => void;
}

export default function ShareLinksPopup({
  title,
  link,
  description,
  onClose,
}: Props) {
  return (
    <ModalLayout onClose={onClose} width="max-w-md">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-1">
          <h4 className="text-xl font-semibold text-neutral-400">{title}</h4>

          {description && (
            <p className="text-sm text-neutral-300">{description}</p>
          )}
        </div>

        <div className="flex gap-5 sm:gap-10 items-start">
          <Link
            to={link}
            className="text-primary-700 text-sm break-all"
            target="_blank"
            rel="noopener noreferrer"
          >
            {link}
          </Link>

          <button onClick={() => handleCopy(link)}>
            <img
              src={copyIcon}
              alt="copy"
              className="w-6 h-6 shrink-0 cursor-pointer"
            />
          </button>
        </div>

        <div className="flex justify-end gap-4">
          <CustomButton text="Close" color="bg-neutral-200" onClick={onClose} />
        </div>
      </div>
    </ModalLayout>
  );
}
